import { styled } from '@material-ui/core';

export const Wrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});
